import apiPrivate from './apiPrivate.service';

const API_URL = '/dm';

class DirectMessageService {
  async getConversations() {
    const response = await apiPrivate.get(`${API_URL}/conversations`);
    return response.data;
  }

  async getConversation(userId) {
    const response = await apiPrivate.get(`${API_URL}/conversation/${userId}`);
    return response.data;
  }

  async sendMessage(userId, content) {
    const response = await apiPrivate.post(`${API_URL}/conversation/${userId}/send`, { content });
    return response.data;
  }
}

export default new DirectMessageService();
